import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * cn — Tailwind-aware class name combiner.
 * Merges conditional classes and resolves Tailwind conflicts
 * (last-one-wins for the same utility).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}